var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuditDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/clipboard-tick"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M13.24 1.6499H4.76004C2.29004 1.6499 0.290039 3.6599 0.290039 6.1199V15.5299C0.290039 17.9899 2.30004 19.9999 4.76004 19.9999H13.23C15.7 19.9999 17.7 17.9899 17.7 15.5299V6.1199C17.71 3.6499 15.7 1.6499 13.24 1.6499Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.35 0H6.65001C5.61001 0 4.76001 0.84 4.76001 1.88V2.82C4.76001 3.86 5.60001 4.7 6.64001 4.7H11.35C12.39 4.7 13.23 3.86 13.23 2.82V1.88C13.24 0.84 12.39 0 11.35 0Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.81 14.9499C7.62 14.9499 7.43 14.8799 7.28 14.7299L5.78 13.2299C5.49 12.9399 5.49 12.4599 5.78 12.1699C6.07 11.8799 6.55 11.8799 6.84 12.1699L7.81 13.1399L11.28 9.66989C11.57 9.37989 12.05 9.37989 12.34 9.66989C12.63 9.95989 12.63 10.4399 12.34 10.7299L8.34 14.7299C8.2 14.8799 8 14.9499 7.81 14.9499Z",
    fill: "#7C7C7C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditDisabled);
export default __webpack_public_path__ + "static/media/auditDisabled.a5306717a86850650df79b7dd60cca3e.svg";
export { ForwardRef as ReactComponent };